import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class AttributesValidatorsActionsValidator {

    name = [
        Validators.required
    ];
    attribute_id = [
        Validators.required
    ];
    operator = [
        Validators.required
    ];
    value = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attribute_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        operator: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        value: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}